
const Breadcrumbs = ({ pages }) => {
    return (
        <>
            <div className="d-flex align-items-center breadcrumbItems" >
                {pages.map((each,index) => (
                    <>
                        <p className={`m-0 ${index==pages.length-1?'text-white':'text-white-50'}`}>{each}</p>
                        {index!==pages.length-1&&<div class="arrow-right mx-3"></div>}
                    </>
                ))}
                {/* <p className="m-0 text-white-50" >Contact</p> */}

            </div>
        </>
    )
}

export default Breadcrumbs